/**
 * Comparación del gasto del mes en curso contra el mes anterior
 * hasta el mismo día (inclusivo). Fechas en calendario local YYYY-MM-DD.
 */

function parseFechaIso(fecha) {
  if (fecha == null || fecha === '') return null;
  const m = String(fecha).match(/^(\d{4}-\d{2}-\d{2})/);
  return m ? m[1] : null;
}

function pad2(n) {
  return String(n).padStart(2, '0');
}

function ultimoDiaDelMes(year, month) {
  return new Date(year, month, 0).getDate();
}

function mesAnteriorDe(year, month) {
  if (month === 1) return { year: year - 1, month: 12 };
  return { year, month: month - 1 };
}

function isoMesDia(year, month, day) {
  return `${year}-${pad2(month)}-${pad2(day)}`;
}

/**
 * Suma cantidad_total de gastos cuyo YYYY-MM-DD cae en [year-month-01, year-month-hasta].
 * `hastaDia` se recorta al último día real del mes (p. ej. 31 vs febrero).
 */
function totalGastosEnMesHastaDia(gastos, year, month, hastaDia, campo = 'cantidad_total') {
  const list = Array.isArray(gastos) ? gastos : [];
  const last = ultimoDiaDelMes(year, month);
  const cap = Math.min(Math.max(1, Number(hastaDia) || 1), last);
  const desde = isoMesDia(year, month, 1);
  const hasta = isoMesDia(year, month, cap);
  return list.reduce((acc, g) => {
    const dia = parseFechaIso(g && g.fecha);
    if (!dia || dia < desde || dia > hasta) return acc;
    const n = parseFloat(g[campo]);
    return acc + (Number.isFinite(n) ? n : 0);
  }, 0);
}

function partesFechaLocal(refDate = new Date()) {
  const d = refDate instanceof Date ? refDate : new Date(refDate);
  return {
    year: d.getFullYear(),
    month: d.getMonth() + 1,
    day: d.getDate()
  };
}

function comparacionMesAnterior(gastos, refDate = new Date()) {
  const { year, month, day } = partesFechaLocal(refDate);
  const prev = mesAnteriorDe(year, month);
  const actual = totalGastosEnMesHastaDia(gastos, year, month, day);
  const anterior = totalGastosEnMesHastaDia(gastos, prev.year, prev.month, day);
  return {
    actual,
    anterior,
    delta: actual - anterior,
    dia: day,
    mesActual: { year, month },
    mesAnterior: prev
  };
}

function formatearImporte(n) {
  return (Number(n) || 0).toFixed(2);
}

function textoDelta(delta) {
  const n = Number(delta) || 0;
  if (Math.abs(n) < 0.005) return '0.00 €';
  const signo = n > 0 ? '+' : '−';
  return `${signo}${Math.abs(n).toFixed(2)} €`;
}

function textoPorcentaje(actual, anterior) {
  const base = Number(anterior);
  if (!base) return null;
  const delta = Math.round(((Number(actual) - base) / base) * 100);
  if (delta === 0) return '0 %';
  const signo = delta > 0 ? '+' : '−';
  return `${signo}${Math.abs(delta)} %`;
}

function textoComparacionMesAnterior({ actual, anterior, dia }) {
  const delta = (Number(actual) || 0) - (Number(anterior) || 0);
  const pct = textoPorcentaje(actual, anterior);
  const lineaDelta = pct ? `${textoDelta(delta)} (${pct})` : textoDelta(delta);
  const lineaCtx = `${formatearImporte(anterior)} € el mes pasado · hasta el día ${dia}`;
  return { lineaDelta, lineaCtx };
}

function claseComparacionMesAnterior(delta) {
  const n = Number(delta) || 0;
  if (Math.abs(n) < 0.005) return 'gastos-mes-comparacion--igual';
  return n > 0 ? 'gastos-mes-comparacion--mas' : 'gastos-mes-comparacion--menos';
}

export {
  parseFechaIso,
  ultimoDiaDelMes,
  mesAnteriorDe,
  totalGastosEnMesHastaDia,
  comparacionMesAnterior,
  textoComparacionMesAnterior,
  claseComparacionMesAnterior,
  textoDelta,
  textoPorcentaje
};
